import React from "react";
import TitleSection from "../components/TitleSection";
import youtube from "../assets/YouTube Squared.svg";
import Facebook from "../assets/Facebook.svg";
import WhatsApp from "../assets/WhatsApp.svg";
import Telegram from "../assets/Telegram App.svg";
import Instagram from "../assets/Instagram.svg";
import { fileUrl } from "../Tools/APIs/useMyAPI";

const Instructors = ({ data }) => {
  const dataAllTeacher = data?.data?.data?.owner_teacher;

  const socialLinks = [
    { icon: Facebook, url: dataAllTeacher?.facebook },
    { icon: Instagram, url: dataAllTeacher?.instagram },
    { icon: WhatsApp, url: dataAllTeacher?.whatsapp },
    { icon: Telegram, url: dataAllTeacher?.telegram },
    { icon: youtube, url: dataAllTeacher?.youtube },
  ];

  return (
    dataAllTeacher?.show === "1" && (
      <section id="instructors" className="flex flex-col  my-20 w-[90%] mx-auto">
        <TitleSection
          title="صاحب المنصة"
          desc={""}
        />

        <div className="flex flex-col bg-gray-100 p-10 md:p-20 rounded-3xl shadow-xl md:flex-row items-center justify-between gap-10 mt-10">
          {/* Left: Teacher Image */}
          <div className="w-full md:w-1/3 flex justify-center">
            <img
              src={`${fileUrl + dataAllTeacher.image}`}
              alt={dataAllTeacher.name}
              className="rounded-2xl shadow-xl w-60 h-60 object-cover"
            />
          </div>

          {/* Right: Name, Desc, Line, Social Links */}
          <div className="w-full md:w-2/3 text-right flex flex-col items-end gap-4">
            <h2 className="text-2xl font-normal text-blue-800 underline">{dataAllTeacher.name}</h2>
            <p className="text-[#555] leading-relaxed max-w-lg">{dataAllTeacher.description}</p>


            <div className="w-80 h-[1px] bg-gray-300" />

            {/* Social Links */}
            <div dir="rtl" className="grid md:grid-cols-2 gap-4 mt-4 w-full ">
              {socialLinks.map(
                (link, idx) =>
                  link.url && (
                    <a
                      key={idx}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 bg-[#f5f5f5] p-3 rounded-xl shadow hover:bg-gray-200 transition"
                    >
                      <img src={link.icon} alt="icon" className="w-6 h-6" />
                      <span className="text-sm font-medium text-[#333]">
                        {(link.url)}
                      </span>
                    </a>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default Instructors;
